import { getPublicBoundlessConfigRetrieveQueryOptions } from "@boundless/bl-api-client/public/services"
import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"

import { FundReadyApp } from "@/components/fundready/FundReadyApp"

export const Route = createFileRoute("/(public)/fundready")({
  validateSearch: z.object({
    partner: z.string().optional().catch(undefined),
  }),
  // Warms the config the gate modal's consent copy reads, so it can't suspend
  // mid-flow. Not returned on purpose: the router would wait on it.
  loader: ({ context: { queryClient } }) => {
    queryClient.prefetchQuery(getPublicBoundlessConfigRetrieveQueryOptions())
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { partner } = Route.useSearch()

  return <FundReadyApp partnerSlug={partner} />
}
